import { render } from "./FormChild.vue?vue&type=template&id=319ba315"
import script from "./FormChild.vue?vue&type=script&lang=js"
export * from "./FormChild.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__